module.exports = __webpack_public_path__ + "static/stageSet3-f30ac131bd628d81e9d7a25922c8bb5f.jpg";